import { Component, Input } from '@angular/core';
import { CardBadgeKind, IDriversLicenseGroup } from '../../driver-background-check.view-models';

@Component({
  selector: 'app-bgc-section-licenses',
  templateUrl: './bgc-section-licenses.component.html',
  styleUrls: ['./bgc-section-licenses.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSectionLicensesComponent {
  @Input() groups: IDriversLicenseGroup[] = [];

  get sectionNote(): string {
    const count = this.groups.reduce((total, grp) => total + grp.cards.length, 0);
    return `${count} driver's license record(s) found`;
  }

  trackByLicenseGroup(index: number, group: IDriversLicenseGroup): string {
    return group.state;
  }

  badgeClass(kind: CardBadgeKind): string {
    return `badge-kind-${kind}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-section-licenses/bgc-section-licenses.component.ts